import React from "react";

// Render a fragment w/o invalid prop warnings
const SafeFragment = ({ key, children, ..._filteredProps }) => (
  <React.Fragment key={key} children={children} />
);

export default SafeFragment;
